import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './contexts/AuthContext';
import theme from './theme';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import SignUpPage from './pages/SignUpPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import BrowsePage from './pages/BrowsePage';
import PostDetailPage from './pages/PostDetailPage';
import CreatePostPage from './pages/CreatePostPage';
import MyPostsPage from './pages/MyPostsPage';
import MessagesPage from './pages/MessagesPage';
import AdminSeedingPanel from './pages/AdminSeedingPanel';
import { ApiTest } from './components/ApiTest';
import { RegistrationDebug } from './components/RegistrationDebug';
import { ApiIntegrationTest } from './components/ApiIntegrationTest';
import { AuthDebug } from './components/AuthDebug';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/browse" element={<BrowsePage />} />
                <Route path="/post/:postId" element={<PostDetailPage />} />
                <Route path="/create-post" element={<CreatePostPage />} />
                <Route path="/my-posts" element={<MyPostsPage />} />
                <Route path="/messages" element={<MessagesPage />} />
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/api-test" element={<ApiTest />} />
                <Route path="/debug-registration" element={<RegistrationDebug />} />
                <Route path="/api-integration-test" element={<ApiIntegrationTest />} />
                <Route path="/auth-debug" element={<AuthDebug />} />
                <Route path="/admin-seeding-panel" element={<AdminSeedingPanel />} />
              </Routes>
            </Layout>
          </Router>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default App;
